/**
 * Centralized constants for Document Class permissions.
 * Follows the pattern: backoffice:document-classes:{action}
 */
export const DOCUMENT_CLASS_PERMISSIONS = {
  VIEW: 'backoffice:document-classes:view',
  CREATE: 'backoffice:document-classes:create',
  UPDATE: 'backoffice:document-classes:update',
  DELETE: 'backoffice:document-classes:delete',
  VIEW_AUDIT_LOG: 'backoffice:document-classes-audit-log:view',
  TAB_ACTIONS_REQUIREMENT: {
    VIEW: 'backoffice:document-classes-tab-actions-requirement:view',
    CREATE: 'backoffice:document-classes-tab-actions-requirement:create',
    UPDATE: 'backoffice:document-classes-tab-actions-requirement:update',
    DELETE: 'backoffice:document-classes-tab-actions-requirement:delete',
  },
} as const;

export type DocumentClassPermission = typeof DOCUMENT_CLASS_PERMISSIONS[keyof typeof DOCUMENT_CLASS_PERMISSIONS];
